/* eslint-disable max-len */
import { cn } from '../cn';

export const IconArrowLeft = ({ className = '' }): JSX.Element => (
  <svg role='img' className = {cn('inline', className)} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5 12H19M5 12L11 18M5 12L11 6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
  </svg>
);
